<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="academyUsers"
  >

    <div class="align-items-baseline display-flex-row">
      <form
        autocomplete="off"
        class="m-form-row m-form-search"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomInputPrimary
            v-model="simpleFilter.academia_url"
            :disabled="pagination.showLoadingState"
            v-on:keyup.enter="searchSimpleFilter"
            name="academia_url"
            placeholder="url de la academia"
            type="text"
            wrapperClass="a-input-wrapper-row"
        />
        <AtomSelectPrimary
          v-model.number="simpleFilter.tipo"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.actors"
          keyField="id"
          name="tipo_actor"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomInputPrimary
          v-model="simpleFilter.email"
          :disabled="pagination.showLoadingState"
          name="email"
          placeholder="usuario@email.com"
          type="email"
          wrapperClass="a-input-wrapper-row"
          @input="searchSimpleFilter"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reload"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <div class="m-dropdown-primary">
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.filter"
          :disabled="pagination.showLoadingState"
          @switchDropDown="$dropDown.switchDropDown"
        />
        <MoleculeEditionBillingAcademyUsersDropDownFilters
          :academiaUrlSeted="simpleFilter.academia_url"
          :filter-seted="filter"
          @reloadListing="reloadListing"
          @searchAdvancedFilter="searchAdvancedFilter"
        />
      </div>

      <form
        autocomplete="off"
        class="m-form-row margin-left-auto"
        name="download-csv-form"
        @submit.prevent="readAcademiaUsuariosExportar"
      >
        <AtomButtonPrimary
          :button-primary="buttonPrimary"
          :disabled="pagination.showLoadingState || !usuarios.length"
        />
      </form>
    </div>

    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="usuarios.length">
          <th
            class="text-align-left"
            width="32%"
          >
            {{ $t('mEditionBillingAcademyUsers.table.thUser') }}
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            {{ $t('mEditionBillingAcademyUsers.table.thDate') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionBillingAcademyUsers.table.thCountry') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionBillingAcademyUsers.table.thProfile') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionBillingAcademyUsers.table.thAccess') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionBillingAcademyUsers.table.thActors') }}
          </th>
        </tr>
        <tr
          v-for="(usuario, index) in usuarios"
          :key="index"
          class="row-data"
        >
          <td class="text-align-left">
            <span class="display-flex-row-center">
              <AtomAvatarSecondary
                avatar-class="medium"
                :user-image="usuario.avatar"
              />
              <span class="display-flex-column user-info">
                <span class="ellipsis">
                  {{ usuario.persona ? usuario.persona.razon_social : usuario.email }}
                </span>
                <small :class="getUserGlobalState(usuario.actores)">
                  {{ usuario.email }}
                </small>
              </span>
            </span>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment.parseZone(usuario.actores[0].fecha_alta).format('D MMM YYYY') }}
          </td>
          <td class="text-align-center">
            <span v-if="usuario.persona !== undefined && usuario.persona.domicilio !== undefined">
              {{ usuario.persona.domicilio.provincia.pais.nombre }}
            </span>
            <span v-else>
              -
            </span>
          </td>
          <td class="text-align-center">
            <a
              :data-tooltip-text="$t('mEditionBillingAcademyUsers.tooltip.profile')"
              :href="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.academyUsers.subject')}/${academiaId}/${$t('mEditionMenu.billing.academyUsers.children.profile.subedition')}/${usuario.id}`"
              class="a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom margin-left-xsmall margin-right-xsmall"
              target="_blank"
            >
              <i class="fas fa-user-astronaut"></i>
            </a>
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.access"
              :disabled="requests.createAcademiaActorResetPassword.isRequested &&
                requests.createAcademiaActorResetPassword.itemLoading !== usuario.id"
              :element="usuario"
              :show-loading="requests.createAcademiaActorResetPassword.isRequested &&
                requests.createAcademiaActorResetPassword.itemLoading === usuario.id"
              @createAcademiaActorResetPassword="createAcademiaActorResetPassword(usuario.id, usuario.actores[0].id)"
            />
          </td>
          <td class="text-align-center">
            <div class="m-dropdown-table">
              <AtomButtonIconRounded
                :button-icon-rounded="buttonIconRounded.actors"
                :particularComponent="`MoleculeEditionBillingAcademyUsersDropDownActors-${index}`"
                @switchDropDown="$dropDown.switchDropDown"
              />
              <MoleculeEditionBillingAcademyUsersDropDownActors
                :actores="usuario.actores"
                :index="index"
              />
            </div>
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import configApp from '@/config'
import { validateEmail } from '@/plugins/validation/validators'

export default {
  name: 'MoleculeEditionBillingAcademyUsers',

  components: {
    MoleculeEditionBillingAcademyUsersDropDownFilters: () => import('@/components/molecules/MoleculeEditionBillingAcademyUsersDropDownFilters'),
    MoleculeEditionBillingAcademyUsersDropDownActors: () => import('@/components/molecules/MoleculeEditionBillingAcademyUsersDropDownActors'),
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academiaId: '',

      buttonIconRounded: {
        access: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom margin-left-xsmall margin-right-xsmall',
          component: '',
          icon: 'fas fa-unlock-alt',
          method: 'createAcademiaActorResetPassword',
          tooltip: this.$t('mEditionBillingAcademyUsers.tooltip.access'),
          type: 'button'
        },

        actors: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom margin-left-xsmall margin-right-xsmall',
          component: '',
          icon: 'fas fa-ellipsis-v',
          method: 'switchDropDown',
          tooltip: this.$t('mEditionBillingAcademyUsers.tooltip.actors'),
          type: 'button'
        }
      },

      buttonPrimary: {
        action: this.$t('mEditionBillingAcademyUsers.buttonPrimary'),
        behavior: 'download',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        download: {
          class: 'a-button-download-secondary margin-left-auto',
          component: '',
          icon: 'fas fa-arrow-to-bottom',
          loading: false,
          method: 'readAcademiaUsuariosExportar',
          text: this.$t('mEditionBillingAcademyUsers.buttonSecondary.downloadText'),
          type: 'button'
        },

        filter: {
          class: 'a-button-billing-secondary a-button-side',
          component: 'MoleculeEditionBillingAcademyUsersDropDownFilters',
          icon: 'fas fa-filter',
          method: 'switchDropDown',
          text: this.$t('mEditionBillingAcademyUsers.buttonSecondary.filterText'),
          type: 'button'
        },

        reload: {
          class: 'a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionBillingAcademyUsers.tooltip.reload'),
          type: 'button'
        }
      },

      filter: {
        email: '',
        fecha_desde: '',
        fecha_hasta: '',
        habilitado: '',
        limite: 10,
        nombre: '',
        pagina: 1,
        pais: '',
        tipo: ''
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      requests: {
        createAcademiaActorResetPassword: {
          itemLoading: '',
          isRequested: false
        }
      },

      showLoadingState: true,

      simpleFilter: {
        academia_url: '',
        email: '',
        tipo: ''
      },

      usuarios: []
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.showLoadingState = true
      this.readAcademiaId()
    }
  },
  created () {
    this.simpleFilter.academia_url = configApp.academyUrl
    this.readAcademiaId()
  },

  methods: {
    createAcademiaActorResetPassword (userId, actorId) {
      if (!this.requests.createAcademiaActorResetPassword.isRequested) {
        this.requests.createAcademiaActorResetPassword.isRequested = true
        this.requests.createAcademiaActorResetPassword.itemLoading = userId
        this.$services.create('academia', 'createAcademiaActorResetPassword', {}, [this.$store.getters.getAcademyData.id, actorId])
          .then(response => {
            this.$alerts.pushAlert('mEditionBillingAcademyUsers', 'createAcademiaActorResetPassword', 'success')
            this.requests.createAcademiaActorResetPassword.isRequested = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionBillingAcademyUsers', 'createAcademiaActorResetPassword', 'error', 'a-alert-danger')
            this.requests.createAcademiaActorResetPassword.isRequested = false
          })
      }
    },

    getUserGlobalState (actores) {
      if (actores.find(actor => actor.habilitado === 1)) {
        return 'ellipsis font-weight-regular text-color-success'
      } else {
        return 'ellipsis font-weight-regular text-color-danger'
      }
    },

    readAcademiaId () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('academia', 'readAcademiaUrl', {}, [this.simpleFilter.academia_url])
          .then(response => {
            this.academiaId = response.data.id
            this.readAcademiaUsuarios()
          })
          .catch(error => {
            console.log(error)
            this.showLoadingState = false
            this.pagination.showLoadingState = false
            this.$alerts.pushAlert('mEditionBillingAcademyUsers', 'readAcademiaId', 'error', 'a-alert-danger')
          })
      }
    },

    readAcademiaUsuarios () {
      this.$services.read('academia', 'readAcademiaUsuarios', {}, [this.academiaId], this.filter)
        .then(response => {
          this.usuarios = []
          this.usuarios = response.data.usuarios
          this.usuarios.forEach(usuario => {
            usuario.actores.sort((a, b) => {
              return Date.parse(a.fecha_alta) - Date.parse(b.fecha_alta)
            })
          })
          this.pagination.currentQuantity = this.usuarios.length
          this.pagination.totalPages = response.data.pages
          this.pagination.totalQuantity = response.data.total
          this.pagination.showLoadingState = false
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.usuarios = []
          this.pagination.currentQuantity = 0
          this.pagination.totalPages = 0
          this.pagination.totalQuantity = 0
          this.pagination.showLoadingState = false
          this.showLoadingState = false
        })
    },

    readAcademiaUsuariosExportar () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.read('academia', 'readAcademiaUsuariosExportar', {}, [this.academiaId], this.filter)
          .then(response => {
            this.$files.downloadCsv(response.data, `${this.$t('mEditionBillingAcademyUsers.files.users')}-${this.$moment().format('YYYYMMDD')}`)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingAcademyUsers', 'readAcademiaUsuariosExportar', 'success')
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingAcademyUsers', 'readAcademiaUsuariosExportar', 'error', 'a-alert-danger')
          })
      }
    },

    reloadListing () {
      this.resetSimpleFilter()
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        email: '',
        fecha_desde: '',
        fecha_hasta: '',
        habilitado: '',
        limite: 10,
        nombre: '',
        pagina: 1,
        pais: '',
        tipo: ''
      }
    },

    resetSimpleFilter () {
      this.simpleFilter = {
        academia_url: configApp.academyUrl,
        email: '',
        tipo: ''
      }
    },

    searchAdvancedFilter (advancedFilter, academiaUrl) {
      this.resetSimpleFilter()
      this.simpleFilter.academia_url = academiaUrl
      this.filter = Object.assign({}, advancedFilter)
      this.setPaginationCurrentPage(1)
    },

    searchSimpleFilter () {
      if (validateEmail(this.simpleFilter.email) ||
        this.simpleFilter.email === '') {
        this.resetAdvancedFilter()
        this.filter.email = this.simpleFilter.email
        this.filter.tipo = this.simpleFilter.tipo
        this.setPaginationCurrentPage(1)
      }
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readAcademiaId()
    }
  }
}
</script>
